export enum ObjectCommentsError {
	// view
	VIEW_NOT_PERMITTED = '403 Forbidden, current user not permitted to use Confluence.',
	// Create
	NO_CREATE_PERMS = 'Could not create content with type comment',
	CONTAINER_NOT_FOUND = 'Content with id %d for comment container is not found. Please provide correct container id.',
	// Admin-configured access-policy rejections. Enforced per-request at the GraphQL gateway and
	// surfaced as the exact reason string (parsed out of the GraphQL error wrapper).
	STEP_UP_AUTH_REQUIRED = 'Step-up authentication is required.',
	IP_ALLOWLIST_BLOCKED = "You're unable to access content because your IP address is not listed in the IP allowlist. Contact your admin for help.",
}
